import type { ReactNode } from 'react';
import Logo240 from './Logo240';
import { previewDestinations } from '../destinations';

export const STUDY_WORD = 'Study';

export interface PreviewNavProps {
  /** Where the Study button goes — see core/returnTo.ts `studyHomeUrl`. */
  studyHref: string;
  onStudyClick?: () => void;
  /** Log in, or the signed-in account menu. */
  accountAction?: ReactNode;
}

/**
 * The same bar the study app puts at the top of every page — logo on the left, a
 * cluster of controls on the right, one hairline underneath — so arriving here from
 * its Labs button does not read as leaving. The study app's header carries a green
 * Labs chip that brought the teacher here; this one carries an orange Study chip
 * that takes them back. Same shape, the other product's colour.
 *
 * Not a `<nav>`: there is nothing to navigate within this page, and the study app
 * reserves that element for its tab row.
 */
export default function PreviewNav({ studyHref, onStudyClick, accountAction }: PreviewNavProps) {
  return (
    <header className="preview-nav">
      <a className="preview-nav-logo" href="/" title="240 Labs" aria-label="240 Labs home">
        <Logo240 className="preview-nav-mark" aria-hidden="true" focusable="false" />
        <span className="preview-nav-name">Labs{previewDestinations(window.location.hostname).development ? ' · Development' : ''}</span>
      </a>
      <div className="preview-nav-cluster">
        <a className="preview-study" href={studyHref} aria-label={STUDY_WORD} onClick={onStudyClick}>
          <svg
            className="preview-study-icon"
            aria-hidden="true"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 7v14" />
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
          </svg>
          <span className="preview-study-word">{STUDY_WORD}</span>
        </a>
        {accountAction}
      </div>
    </header>
  );
}
